import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

import routerCities from "@/router/cities";
import routerExcursionHalls from "@/router/ExcursionHalls";
import routerMuseums from "@/router/museums";
import routerExhibitions from "@/router/exhibitions";
import routerShows from "@/router/shows";
import routerVideos from "@/router/videos";
import routerHub from "@/router/hub";
import routerActivations from "@/router/activations";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * disabled: true                 if set true, item will disabled link in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    activeMenuParent: true     if set true, the parent item will highlight
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: { title: "Главная", icon: "dashboard" },
      },
    ],
  },
  {
    path: "/hub",
    component: Layout,
    meta: { title: "Хаб", icon: "tree" },
    redirect: "/hub/edit/1",
    children: routerHub("/hub"),
  },
  {
    path: "/cities",
    component: Layout,
    meta: { title: "Города", icon: "city-solid" },
    redirect: "/cities/list",
    children: routerCities("/cities"),
  },
  {
    path: "/museums",
    component: Layout,
    meta: { title: "Музеи / площадки", icon: "palette-solid" },
    redirect: "/museums/list",
    children: routerMuseums("/museums"),
  },
  {
    path: "/activations",
    component: Layout,
    meta: { title: "Активации музея / площадки", icon: "elementor-brands" },
    redirect: "/activations/list",
    children: routerActivations("/activations"),
  },
  {
    path: "/excursion-halls",
    component: Layout,
    meta: { title: "Экскурсионные залы", icon: "mask-solid" },
    redirect: "/excursion-halls/list",
    children: routerExcursionHalls("/excursion-halls"),
  },
  {
    path: "/exhibitions",
    component: Layout,
    meta: { title: "Аудиотреки", icon: "file-audio-solid" },
    redirect: "/exhibitions/list",
    children: routerExhibitions("/exhibitions"),
  },
  {
    path: "/shows",
    component: Layout,
    meta: { title: "Выставки и мероприятия", icon: "calendar-alt-solid" },
    redirect: "/shows/list",
    children: routerShows("/shows"),
  },
  {
    path: "/videos",
    component: Layout,
    meta: { title: "Видео", icon: "youtube-brands" },
    redirect: "/videos/list",
    children: routerVideos("/videos"),
  },
  { path: "*", redirect: "/404", hidden: true },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
